import { createReducer, on } from "@ngrx/store";
import { GenericUserData } from "src/model/interface/generic-user-data";
import {
  currentUserSetAction,
  currentUserUnsetAction,
  currentUserUpdateConsents,
  currentUserUpdateData,
  currentUserUpdatePassword,
} from "../actions/authentication.actions";

/**
 * Memeber export for authentication reducer
 *
 * @param action
 * @param state
 * @returns
 */
export const AuthenticationReducer = createReducer(
  null,
  on(currentUserSetAction, (currentUserData: GenericUserData, action) => {
    //return { currentUser: action.currentUser };
    const user: GenericUserData = {
      ...currentUserData,
      currentUser: action.currentUser,
    };

    return user;
  }),
  on(currentUserUpdateData, (currentUserData: GenericUserData, action) => {
    const user: GenericUserData = {
      ...currentUserData,
      currentUser: {
        ...currentUserData.currentUser,
        name: action.name,
        surname: action.surname,
      },
    };

    return user;
  }),
  on(currentUserUpdateConsents, (currentUserData: GenericUserData, action) => {
    const user: GenericUserData = {
      ...currentUserData,
      currentUser: {
        ...currentUserData.currentUser,
        commercialComunication: action.commercialComunication,
        personalizingService: action.personalizingService,
      },
    };

    return user;
  }),
  on(currentUserUpdatePassword, (currentUserData: GenericUserData, action) => {
    const user: GenericUserData = {
      ...currentUserData,
      currentUser: {
        ...currentUserData.currentUser,
        password: action.password,
      },
    };

    return user;
  }),

  on(currentUserUnsetAction, (currentUser: GenericUserData, action) => {
    return {
      currentUser: null,
    };
  })
);
//#endregion
